import { SquareConnectorsActionTypes } from './constants';

const INIT_STATE = { error: null, loading: false };

const SquareConnectors = (state = INIT_STATE, action) => {
    switch (action.type) {
        case SquareConnectorsActionTypes.CREATE_INTEGRATION_AND_START_OAUTH_REQUEST:
            return { ...state, error: null, loading: true };
        case SquareConnectorsActionTypes.API_RESPONSE_SUCCESS:
            return { ...state, loading: false };
        case SquareConnectorsActionTypes.API_RESPONSE_ERROR:
            return { ...state, error: action.payload.error, loading: false };
        default:
            return state;
    }
};

export default SquareConnectors;
